// Map API endpoints here
import { toCalendarDateYmd } from '@/helpers';

export default $axios => ({
  availableDates(itemIds, pickupPoint = null) {
    const url = '/api/availableDates';
    const params = {
      itemIds,
      itemType: 'product'
    };

    if (pickupPoint) params.pickupPoint = pickupPoint;

    return $axios.get(url, { params });
  },
  book(partnerUserId, products) {
    const url = `/api/partnerUser/${partnerUserId}/itemDates`;

    return $axios.post(url, { products });
  },
  availableTimes(itemIds, date, pickupPoint = null) {
    const url = '/api/availableTimes';
    const params = {
      itemIds,
      itemType: 'product',
      date: toCalendarDateYmd(date)
    };

    if (pickupPoint) params.pickupPoint = pickupPoint;

    return $axios.get(url, { params });
  },
  pickupPoints(productId) {
    const url = `/api/pickupPoints?productId=${productId}`;

    return $axios.get(url);
  },
  redeemProduct(params, rootState = false) {
    let url;
    const { isPreview } = rootState.offer;

    if (isPreview) {
      url =
        params.type === 'check-in'
          ? `/api/preview/checkIn`
          : `/api/preview/redeem`;
    } else {
      url =
        params.type === 'check-in'
          ? `/api/partnerUser/${params.partnerUserId}/checkIn`
          : `/api/partnerUser/${params.partnerUserId}/redeem`;
    }

    return $axios.post(url, params);
  },
  getProductById(params = {}) {
    return $axios.get(`/products/${params.productId}`, params);
  }
});
